import React from 'react'
import Hubnav from '../Hubnav'
import { useNavigate } from 'react-router-dom';
const DeliveryBoyConfig = () => {
    var nav=useNavigate()
    function add(){
          nav('/DistributionHubPanel/DeliveryBoyConfig/AddDeliveryBoy')
    }
    function remove(){
          nav('/DistributionHubPanel/DeliveryBoyConfig/RemoveDeliveryBoy')
    }
  
    return (
    <>
    <Hubnav/>
   <div className="card h-100 text-center panel" >
                <div className="card-body row ">
                <i className="fas fa-user-plus col icons" onClick={()=>add()}></i>
                <i className="fas fa-user-slash col icons" onClick={()=>remove()}></i>
                </div>
                <div className="card-body row content">
                <b className="col" style={{paddingLeft:"3.0px"}}>Add Delivery Boy</b>
                <b className="col" style={{marginLeft:"25px"}}>Remove Delivery Boy</b>
                </div>
            </div>
    </>
  )
}

export default DeliveryBoyConfig